<template>
    <div>
        <div class="typewriter-container">
            <span class="typewriter-text">{{ typewriterText }}</span>
            <span class="cursor"></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        textToType: {
            type: String,
            required: true,
        },
        typingSpeed: {
            type: Number,
            default: 100, // Default typing speed if not provided from the parent
        },
    },
    data() {
        return {
        typewriterText: "", // The text being "typed" with the typewriter effect
        showCursor: false,
        };
    },
    methods: {
        typeEffect() {
        let index = 0;
        const text = this.textToType;
        const speed = this.typingSpeed;

        const typeNextChar = () => {
            if (index < text.length) {
                this.typewriterText += text.charAt(index);
                index++;
                setTimeout(typeNextChar, speed);
            } else {
                this.showCursor = !this.showCursor; // Toggle cursor when typing is finished
            }
        };

        typeNextChar();
        },
    },
    mounted() {
        this.typeEffect();
    },
};
</script>

<style scoped>
    .typewriter-container {
        position: relative;
    }

    .typewriter-text {
        display: inline;
    }

    .cursor {
        display: inline-block;
        width: 0.5em; /* Customize cursor width */
        height: 1em; /* Customize cursor height */
        margin: 0 0 -0.2em 3px;
        background-color: black; /* Customize cursor color */
        animation: blinkCursor 1s infinite;
    }

    @keyframes blinkCursor {
        0%, 100% {
            opacity: 1; /* Set opacity to 1 to make the cursor visible */
        }
        50% {
            opacity: 0; /* Set opacity to 0 to make the cursor invisible */
        }
    }
</style>